import { Button, Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";

const UserModal = ({ visible, onCancel, onSubmit, initialValues }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setLoading(false);
      form.resetFields(); // Reset form fields when the modal is opened
      form.setFieldsValue(initialValues || { user_type: 2 }); // Set initial values or default to user_type = 2
    }
  }, [visible, form, initialValues]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        onSubmit(values);
        // setTimeout(() => {
        //   setLoading(false);
        //   form.resetFields();
        //   onCancel();
        // }, 2000); // Simulate API call
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };

  return (
    <Modal
      className="manage-user-form-modal"
      visible={visible}
      title={initialValues ? "Edit User" : "Create a New User"}
      onCancel={onCancel}
      footer={[
 
        <>
        <button type="button" className="btn btn-light fs-7 fw-bold" key="back" onClick={onCancel}>Close</button>
        <button type="button" className="btn btn-danger fs-7 fw-bold" loading={loading} onClick={handleOk}> {initialValues ? "Update" : "Submit"}</button>
      </>
      ]}
    >
      <Form form={form} layout="vertical" name="userForm">
        <Form.Item
          name="name"
          label="Name"
          className="form-check-label manage-user-form-label fw-bold"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input placeholder="Enter your name" className="form-control form-control-solid manage-user-form-input"/>
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          className="form-check-label manage-user-form-label fw-bold mb-0"
          rules={[
            { required: true, message: "Please input your email!" },
            { type: "email", message: "Please enter a valid email!" },
          ]}
        >
          <Input placeholder="Enter your email" className="form-control form-control-solid manage-user-form-input"/>
        </Form.Item>

        {!initialValues && (
          <>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password placeholder="Enter your password" />
            </Form.Item>
            <Form.Item
              name="confirm_password"
              label="Confirm Password"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Please confirm your password!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm your password" />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default UserModal;
